export default __webpack_public_path__ + "static/media/home-img-2.f465a7c8.png";